import { render, staticRenderFns } from "./TextFieldStudy.vue?vue&type=template&id=1f30a871&scoped=true&lang=pug"
import script from "./TextFieldStudy.vue?vue&type=script&lang=ts"
export * from "./TextFieldStudy.vue?vue&type=script&lang=ts"
import style0 from "./TextFieldStudy.vue?vue&type=style&index=0&id=1f30a871&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f30a871",
  null
  
)

export default component.exports